// src/components/imagepicker/PickerToolbar.jsx
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import UploadIcon from "@mui/icons-material/CloudUpload";
import ImageIcon from "@mui/icons-material/Image";
import styles from "./styles/styles.module.scss";

export default function PickerToolbar({
    title = "����������",
    busy = false,
    onUploadClick,
    onOpenLibrary,
}) {
    return (
        <Box className={styles.toolbarWrap}>
            <Typography variant="subtitle2" className={styles.toolbarTitle}>
                {title}
            </Typography>

            <Box className={styles.controls}>
                <Button
                    variant="contained"
                    startIcon={<UploadIcon sx={{ color: "#000" }} />}
                    onClick={onUploadClick}
                    disabled={busy}
                >
                    Завантажити
                </Button>

                <Button
                    variant="text"
                    startIcon={<ImageIcon sx={{ color: "#000" }} />}
                    onClick={onOpenLibrary}
                    disabled={busy}
                >
                    Бібліотека
                </Button>
            </Box>
        </Box>
    );
}